module.exports = __webpack_public_path__ + "static/img/img03.d854b05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img03.jpg
// module id = OcrQ
// module chunks = 18